import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { format } from 'date-fns';
import Banner from '../global/Banner';
import RedesignRevertDialog from '../businesses/RedesignRevertDialog';
import useBusinessWebRedesignBanner from '../../hooks/businesses/useBusinessWebRedesignBanner';
import useBusinessWebRedesignToggle from '../../hooks/businesses/useBusinessWebRedesignToggle';
import { REDESIGN_CLASSIC_SUNSET } from '../../constants/redesign';

function BusinessWebRedesignBanner() {
  const { isBannerShown, enabled, hideBanner } = useBusinessWebRedesignBanner();
  const { isSaving, setEnabled } = useBusinessWebRedesignToggle();
  const [revertOpen, setRevertOpen] = useState(false);

  const sunset = REDESIGN_CLASSIC_SUNSET
    ? `Classic goes away ${format(REDESIGN_CLASSIC_SUNSET, 'MMMM d')}.`
    : null;

  const onClick = async () => {
    if (enabled) {
      setRevertOpen(true);
      return;
    }
    if (!isSaving) await setEnabled(true);
  };

  return (
    <>
      <Banner
        isVisible={isBannerShown}
        hideBanner={hideBanner}
        action={{ onClick }}>
        <Typography variant="h5" color="inherit">
          {enabled
            ? "You're on the new Porter design."
            : 'Try the new Porter design'}
        </Typography>
        <Box display={{ xs: 'none', sm: 'flex' }} alignItems="center">
          <Typography variant="body2" color="inherit" marginLeft={1}>
            {enabled
              ? [sunset, 'Switch back to classic'].filter(Boolean).join(' ')
              : 'Redesigned calendar, sidebar, and checkout. Switch back anytime.'}
          </Typography>
        </Box>
      </Banner>
      {enabled && (
        <RedesignRevertDialog
          open={revertOpen}
          onClose={() => setRevertOpen(false)}
          onConfirm={reason => setEnabled(false, reason)}
          isSaving={isSaving}
        />
      )}
    </>
  );
}

export default BusinessWebRedesignBanner;
